import { createColumnHelper } from '@tanstack/table-core';
import WebhooksTableStatus from './webhooks-table-status';
import { StickyOptions } from 'common/components/table/tableTypes';
import WebhooksTableActions from './webhooks-table-actions';
import { Webhook } from '../webhooks.models';

const columnHelper = createColumnHelper<Webhook>();

export const getWebhooksColumnDefs = () => [
  columnHelper.accessor((row) => row.name, {
    id: 'Name',
    header: () => 'Name',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.webhookType, {
    id: 'WebhookType',
    header: () => 'Webhook Type',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.status, {
    id: 'WebhookStatus',
    header: () => 'Status',
    enableColumnFilter: false,
    cell: (info) => (
      <WebhooksTableStatus
        currentStatus={info.getValue()}
        webhookId={info.row.original.id}
      />
    )
  }),
  columnHelper.accessor((row) => row.webhookUrl, {
    id: 'WebhookUrl',
    header: () => 'Url',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate" title={info.getValue()}>
        {info.getValue()}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.description, {
    id: 'Description',
    header: () => 'Description',
    enableColumnFilter: false,
    cell: (info) => (
      <div className="text-sm truncate" title={info.getValue()}>
        {info.getValue()}
      </div>
    )
  }),
  columnHelper.accessor((row) => row.lastUpdatedDate, {
    id: 'LastUpdatedDate',
    header: () => 'Last Updated Date',
    enableColumnFilter: false,
    cell: (info) => <div className="text-sm truncate">{info.getValue()}</div>
  }),
  columnHelper.accessor((row) => row.id, {
    id: 'actions',
    header: () => 'Actions',
    enableColumnFilter: false,
    cell: (info) => <WebhooksTableActions webhook={info.row.original} />,
    maxSize: 50,
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'right'
      } as StickyOptions
    }
  })
];
